import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from 'src/app/lib/alert-banner';
import {SurveyService} from 'src/app/services/survey/survey.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-share-report-modal',
  templateUrl: './share-report-modal.component.pug',
  styleUrls: ['./share-report-modal.component.scss'],
  standalone: false
})
export class ShareReportModalComponent implements OnInit {

  @Input() checkId;
  @Input() refereeId;

  bannerText = $localize`The email will be sent in the platform's current language setting. Users can modify the display language within the shared report.`
  selectDomainText = $localize`Select domain`;
  emailPlaceHolder = $localize`Enter email address`;
  email_username = '';
  email_domain = '';
  domains: any;
  workEmailErrors: any;
  focus_input = false;
  constructor(public _bsModalRef: BsModalRef,
              private alertList: AlertBannerService, public surveyService: SurveyService, private permissionsService: PermissionsService) {
  }
  ngOnInit(): void {
    this.getCompanyDomains();
  }

  getCompanyDomains() {
    const getDomainsSuccess = (resp) => {
      this.domains = resp.data.domains.map((domain) => {
        return {value: domain}
      });

    };

    const getDomainsError = () => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    };

    this.surveyService
      .getCompanyDomains().subscribe(getDomainsSuccess, getDomainsError);
  }


  cancel() {
    this._bsModalRef.hide()
  }

  changeValue() {
    this.focus_input = true
    this._bsModalRef.content = {email: this.email_username + '@' + this.email_domain}
  }


  dropDownOptionSelected($event: any) {
    this.email_domain = $event.value
  }

  submit() {
    let payload = {
      email: this.email_username + '@' + this.email_domain
    }
    this.shareReport(this.checkId, this.refereeId, payload)
    this._bsModalRef.hide()
  }

    shareReport(checkId: number, refereeId: number, email_payload: any) {
    this.surveyService.apiShareReportPost(checkId, refereeId, email_payload).subscribe(
      (response) => {
        let successMessage = '';
        if (response && response.status_message == 'ok') {
          successMessage = $localize`Success! An email was sent to ${email_payload.email}.`;
        }

        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: successMessage,
          keepOnRouteChange: true
        }]);
      },
      (error) => {
        let errorMessage = '';
        if (error.status === 400) {
          errorMessage = $localize`Invalid request. Please check your inputs and try again.`;
        } else if (error.status === 404) {
          errorMessage = $localize`Resource not found. Please ensure you have the necessary permissions.`;
        } else {
          errorMessage = $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`;
        }

        this.alertList.append([{
          type: AlertType.DANGER,
          message: errorMessage,
          keepOnRouteChange: true
        }]);
      }
    );
  }

  checkWorkEmail(workEmail:string) {
    const mailRegex = /^[a-zA-Z0-9._%+-]+$/
    return mailRegex.test(workEmail)
  }
}
